var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-user-setting',{staticClass:"pt-user-setting__withData"})
}
var staticRenderFns = []

export { render, staticRenderFns }